import { Accordion, AccordionSummary, AccordionDetails, Box, Typography, TextField } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { SkillRatingStars } from './SkillRatingStars'
import type { SkillCategory, SkillRating } from '../../../types/skills'
import type { FixedSkillRating } from '../types'
import { CATEGORY_LABELS, getSkillsByCategory } from '../../../types/skills'

interface FixedSkillCategoryProps {
  category: SkillCategory
  expanded: boolean
  onExpandedChange: (expanded: boolean) => void
  ratings: Record<string, FixedSkillRating>
  onRatingChange: (careerField: string, rating: SkillRating | null) => void
  onDescriptionChange: (careerField: string, description: string) => void
}

export function FixedSkillCategory({
  category,
  expanded,
  onExpandedChange,
  ratings,
  onRatingChange,
  onDescriptionChange,
}: FixedSkillCategoryProps) {
  const skills = getSkillsByCategory(category)
  const categoryLabel = CATEGORY_LABELS[category]

  // このカテゴリーにレーティングが設定されているスキル数をカウント
  const ratedCount = skills.filter((skill) => {
    const skillData = ratings[skill.careerField]
    return skillData && skillData.rating !== null
  }).length

  return (
    <Accordion expanded={expanded} onChange={(_, isExpanded) => onExpandedChange(isExpanded)}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="subtitle1" fontWeight="bold">
          {categoryLabel}
          {ratedCount > 0 && (
            <Typography component="span" variant="caption" sx={{ ml: 1, color: '#667eea' }}>
              ({ratedCount})
            </Typography>
          )}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {skills.map((skill) => {
            const skillData = ratings[skill.careerField] || { rating: null, description: '' }
            return (
              <Box
                key={skill.careerField}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                  padding: 1.5,
                  backgroundColor: '#f9f9f9',
                  borderRadius: 1,
                  border: '1px solid #e0e0e0',
                }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography variant="body2" sx={{ flex: 1, fontWeight: 500 }}>
                    {skill.label}
                  </Typography>
                  <SkillRatingStars
                    rating={skillData.rating}
                    onChange={(rating) => onRatingChange(skill.careerField, rating)}
                    tooltips={skill.tooltips}
                  />
                </Box>
                <TextField
                  value={skillData.description}
                  onChange={(e) => onDescriptionChange(skill.careerField, e.target.value)}
                  placeholder="説明（任意）"
                  size="small"
                  multiline
                  rows={2}
                  fullWidth
                />
              </Box>
            )
          })}
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}
